import { BalanceLevel } from 'multirpc-sdk';

import { ChargingModel } from 'modules/billing/types';
import { PAYGLabel } from 'modules/common/components/PAYGLabel';
import { UserLabel } from 'uiKit/UserLabel';
import { selectPAYGBalance } from 'modules/billing/store/selectors';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAppSelector } from 'store/useAppSelector';

interface IChargingModelLabelParams {
  chargingModel: ChargingModel | undefined;
  className?: string;
  size: 'small' | 'medium' | 'large';
}

export const ChargingModelLabel = ({
  chargingModel,
  className,
  size = 'medium',
}: IChargingModelLabelParams) => {
  const { group, isFinance } = useAccount();

  const { balanceLevel } = useAppSelector(state =>
    selectPAYGBalance(state, group),
  );

  const isDeal = chargingModel?.type === 'deal';
  const isPackage = chargingModel?.type === 'package';
  const hasActiveBundle = isDeal || isPackage;
  const isPAYGBalanceNeverToppedUp = balanceLevel === BalanceLevel.UNKNOWN;

  if (isPAYGBalanceNeverToppedUp && isFinance && !hasActiveBundle) {
    return null;
  }

  switch (chargingModel?.type) {
    case 'payg':
      return <PAYGLabel size={size} className={className} />;
    case 'freemium':
      return (
        <UserLabel
          hasPremium={false}
          hasEnterpriseStatus={false}
          hasStatusTransition={false}
          isLoading={false}
          size={size}
          className={className}
        />
      );
    default:
      return (
        <UserLabel
          chargingModelType={chargingModel?.type}
          className={className}
          hasEnterpriseStatus={false}
          hasPremium={false}
          hasStatusTransition={false}
          isLoading={false}
          size={size}
        />
      );
  }
};
